<ng-container *ngIf="assetGroupForm && !loading">
    <p-toast key="assetGroupNameMissing" position="top-left"></p-toast>
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"
                     acceptButtonStyleClass="cas-button-action"></p-confirmDialog>
    <form [formGroup]="assetGroupForm" class="cas-form-floating">
        <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Name</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" formControlName="name" id="asset-type-name" placeholder="Enter an asset type name" />
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Description</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" formControlName="description" id="asset-type-description" placeholder="Enter an asset type description" />
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="onCancel()">Cancel</button>
            <button (click)="onAssetGroupDeleteSubmit()">Delete</button>
            <button class="cas-button-action cas-button-right" (click)="onAssetGroupUpdateSubmit()">Update</button>
        </div>
    </form>
</ng-container>
<ng-container *ngIf="!assetGroupForm">
    <acabim-loading-view></acabim-loading-view>
</ng-container>
